import { RecoverableBinding, recoverableField } from "../../../ServiceDesk/recovery/recoverable-control";

export class TextFieldBinding extends RecoverableBinding {
  /** The model to bind the text field to. */
  public text = "=";

  /** The type of text field. Supported types are "text" | "email" | number" | "tel"
   *  Can be used for field validation.
   */
  public textFieldType = "@?";

  /** If this text field should not be modified by user interaction. Defaults to false. */
  public isReadonly = "<?";

  /** String value for 'labeling' (introduction text, typically above) the text field. */
  public label = "@?";

  /** String value for 'captioning' (annotation text, typically below) the text field. */
  public caption = "@?";

  /** Placeholder text for the text field. When not provided, the placeholder will be empty. */
  public placeholder = "@?";

  /** Sets the controls required attribute to true or false. */
  public isRequired = "@?";

  /** Sets the controls required attribute to true or false. */
  public hidelabel = "@?";

  /** The maximum characters allowed in the input. One time binding only. */
  public maxLength = "@?";

  /** Called when the model text changes, takes a text: string as a parameter */
  public onTextChange = "&";

  /** Sets the invalid message content */
  public invalidMessage = "@?";

  /** Sets the pattern for the text field. No need to pass this value if textFieldType is Email,
   * it needs to be a RegExp
   */
  public pattern = "@?";

  public ariaLabelledby = "@?";
  public name = "@?";
}

/** Various input types to be used. */
export type TextFieldType = "text" | "email" | "number" | "tel";
export class TextFieldController {
  @recoverableField
  public text: any;
  public textFieldType: TextFieldType;
  public isReadonly: boolean;
  public label: string;
  public caption: string;
  public placeholder: string;
  public hidelabel: string;
  public pattern: RegExp;
  public onTextChange: (object: { text: string }) => void;
  public name: string;

  constructor() {
    if (this.textFieldType == "email") {
      this.textFieldType = "text";
      this.pattern =
        /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    }
  }

  public onChange() {
    this.onTextChange({ text: this.text });
  }
}
export const sdTextField: ng.IComponentOptions = {
  controller: TextFieldController,
  templateUrl: "../ShellCommon/Controls/text-field/text-field.html",
  bindings: <any>new TextFieldBinding()
};
